var _circle, _circle2, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgQuestionCircleSvgrepoCom(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 4.5,
    stroke: "#273B4A"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 9,
    r: 0.25,
    fill: "#273B4A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 8V7.57161C6 7.2145 6.17848 6.88102 6.47561 6.68293L6.77484 6.48344C7.22788 6.18141 7.5 5.67295 7.5 5.12847V5C7.5 4.17157 6.82843 3.5 6 3.5V3.5C5.17157 3.5 4.5 4.17157 4.5 5V5",
    stroke: "#273B4A"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionCircleSvgrepoCom);
export default __webpack_public_path__ + "static/media/question-circle-svgrepo-com.3bc4c9283a4d6c149a98d8b369f93955.svg";
export { ForwardRef as ReactComponent };